import axios from './axios'

// Логин пользователя
export const login = async credentials => {
        const response = await axios.post('/login', credentials)
        return response.data
}

// Регистрация пользователя
export const register = async userData => {
        const response = await axios.post('/register', userData)
        return response.data
}

export const forgotPassword = async userData => {
        const response = await axios.post('/forgot-password', userData)
        return response.data
}

export const validateResetToken = async token => {
        const response = await axios.get(`/reset-password/${token}`)
        return response.data
}

export const resetPassword = async (token, password) => {
        const response = await axios.post(`/reset-password/${token}`, { password })
        return response.data
}

export const passwordRecovery = async userData => {
        const response = await axios.post('/password-recovery', userData)
        return response.data
}
export const emailVerification = async userData => {
        const response = await axios.post('/verify-email', userData)
        return response.data
}

// Получение данных текущего пользователя
export const fetchCurrentUser = async () => {
        const response = await axios.post('/profile')
        return response.data
}

// Обновление данных профиля пользователя
export const updateProfile = async (userData, onUploadProgress = null) => {
        if (userData instanceof FormData) {
                // Загрузка файла — multipart/form-data
                const config = {
                        headers: { 'Content-Type': 'multipart/form-data' },
                        timeout: 120000,
                }
                if (onUploadProgress) {
                        config.onUploadProgress = onUploadProgress
                }
                const response = await axios.post('/profile/update', userData, config)
                return response.data
        } else {
                // Обычные данные — JSON
                const response = await axios.post('/profile/update', userData)
                return response.data
        }
}

// Обновление пароля пользователя
export const updatePassword = async passwordData => {
        const response = await axios.post('/profile/password', passwordData)
        return response.data    
}

// Выход из системы
export const logout = async () => {
        const response = await axios.post('/logout')
        return response.data
}
